// NotificationBell.js - Bell icon with unread count badge

import React from 'react';
import { FaBell } from 'react-icons/fa';
import { useNotifications } from './NotificationContext';
import { useTranslation } from 'react-i18next';
import './Notifications.css';

/**
 * NotificationBell component - displays bell icon with unread count
 * Shows in header next to user profile
 */
const NotificationBell = () => {
  const { t } = useTranslation('common');
  const { 
    unreadCount, 
    isDropdownOpen, 
    toggleDropdown, 
    isLoading 
  } = useNotifications();

  const handleBellClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleDropdown();
  };

  return (
    <div className="NTS-notification-bell-container">
      <button
        className={`NTS-notification-bell ${isDropdownOpen ? 'active' : ''} ${isLoading ? 'loading' : ''}`}
        onClick={handleBellClick}
        title={t('notifications.bell_tooltip', { count: unreadCount })}
        aria-label={`${unreadCount} unread notifications`}
        disabled={isLoading}
      >
        <FaBell className="NTS-bell-icon" />
        
        {unreadCount > 0 && (
          <span className="NTS-notification-badge">
            <span className="NTS-badge-content">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          </span>
        )}
        
        {isLoading && (
          <div className="NTS-bell-loading-indicator">
            <div className="NTS-loading-spinner"></div>
          </div>
        )}
      </button>
    </div>
  );
};

export default NotificationBell;
